import { CommerceProperty } from '@msdyn365-commerce/retail-proxy';
import getExtensionPropertyValueByKey, { CommercePropertyValueEnum } from './getExtensionPropertyValueByKey';
import { SupersessionKey } from '../themes/gardner-theme/models/SupersessionKey';

interface CheckAlternateWarehouseFeatureParams {
    extensionProperties: CommerceProperty[] | undefined;
    allowedDealerTypes: string[];
    designatedCustomerGroupsArr: string[];
    authorizedWarehouseAccounts: string[];
    isAlternateWarehouseFeatureEnabled: boolean;
    customerAccNum: string | undefined;
}

export interface AdditionalAltWarehouseDetails {
    CustomerGroup: string;
    FreightTermCodeId: string;
    ProductCode: string;
}

export const getAdditionalAltWarehouseDetails = (extensionProperties: CommerceProperty[] | undefined) => {
    return getExtensionPropertyValueByKey(
        extensionProperties,
        SupersessionKey.AltWarehouseAdditional,
        CommercePropertyValueEnum.string
    ) as string;
};

export const checkAlternateWarehouseFeatureAccess = async ({
    extensionProperties,
    allowedDealerTypes,
    designatedCustomerGroupsArr,
    authorizedWarehouseAccounts,
    isAlternateWarehouseFeatureEnabled,
    customerAccNum
}: CheckAlternateWarehouseFeatureParams): Promise<boolean> => {
    if (!customerAccNum) {
        return false;
    }

    const additionalAltWarehouseDetails = JSON.parse(
        getAdditionalAltWarehouseDetails(extensionProperties)
    ) as AdditionalAltWarehouseDetails;

    if (!additionalAltWarehouseDetails) {
        return false;
    }

    return (
        allowedDealerTypes.includes(additionalAltWarehouseDetails.FreightTermCodeId) &&
        designatedCustomerGroupsArr.includes(additionalAltWarehouseDetails.CustomerGroup) &&
        (isAlternateWarehouseFeatureEnabled || (typeof customerAccNum === 'string' && authorizedWarehouseAccounts.includes(customerAccNum)))
    );
};

/**
 * Converts a comma- or semicolon-separated string into an array of trimmed strings.
 * For example, "a, b; c" becomes ["a", "b", "c"].
 *
 * @param str - The comma- or semicolon-separated string.
 * @returns An array of trimmed string values.
 */
export const convertStringToArray = (str: string) => {
    return str?.split(/[;,]+/).map(ele => ele.trim()) ?? [];
};

export const getIsAlternateWarehouse = ({
    designatedDealerTypesArr,
    productCodeWhitelistArr,
    extensionProperties
}: {
    designatedDealerTypesArr: string[];
    productCodeWhitelistArr: string[];
    extensionProperties: CommerceProperty[] | undefined;
}) => {
    const additionalAltWarehouseDetails = JSON.parse(
        getAdditionalAltWarehouseDetails(extensionProperties)
    ) as AdditionalAltWarehouseDetails;
    if (!additionalAltWarehouseDetails) {
        return true;
    }

    if (designatedDealerTypesArr.includes(additionalAltWarehouseDetails.FreightTermCodeId)) {
        if (productCodeWhitelistArr.includes(additionalAltWarehouseDetails.ProductCode)) {
            return false;
        }
    }
    return true;
};
